"use strict";

import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    adminFlag: false,
    noticeList: [],
    newsList: [],

  },
  getters: {

    getNewsList: state => {
      return state.newsList;
    },
    getNoticeList: state => {
      return state.noticeList;
    },

    getAdmin: state => {
      return state.adminFlag;
    },

  },
  mutations: {
    setNewsList: (state, payload) => {
      state.newsList = payload;
    },
    setNoticeList: (state, payload) => {
      state.noticeList = payload;
    },
    setAdmin: (state, payload) => {
      state.adminFlag = payload;
    },
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js